import React, { useEffect, useRef } from 'react';
import { LinearProgress, makeStyles } from '@material-ui/core';
import handleViewport from 'react-in-viewport';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    overflowY: 'auto',
  },
}));

const InfiniteScroll = ({ fetchMore, hasMore, children, loading }) => {
  const classes = useStyles();
  const containerRef = useRef();

  const Block = (props) => {
    const { inViewport, forwardedRef } = props;
    return <div ref={forwardedRef}></div>;
  };

  const ViewportBlock = handleViewport(Block);

  function handleCheckFetchMore() {
    hasMore && fetchMore();
  }

  return (
    <div className={`${classes.root} bottom-overflow-fade`} ref={containerRef}>
      {children}
      <ViewportBlock onEnterViewport={handleCheckFetchMore} />
      {loading && <LinearProgress />}
    </div>
  );
};

export default React.memo(InfiniteScroll);
